import { type ReactNode } from 'react';

interface SectionLabelProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export const SectionLabel = ({ children, icon, className = '' }: SectionLabelProps) => {
  return (
    <div className={`text-xs font-semibold text-muted uppercase tracking-wider flex items-center gap-1.5 ${className}`}>
      {icon}
      {children}
    </div>
  );
};
